module.exports = __webpack_public_path__ + "static/media/Find_levers_2.a55789e4.png";